import React from 'react';
import styled from 'styled-components';
import boss from '../../../../assets/png/boss.png';
import {
  COLORS,
  CONTACT_US_TITLE,
  CTA_DESCRIPTION,
  device,
  FONTS,
  ROUTES,
} from '../../../../constants';
import { Text, Title } from '../../../../components';
import { NavLink as Link } from 'react-router-dom';
import { CtaPhoto } from '../../../../components/CtaPhoto/CtaPhoto';
import { MotionText } from '../../../../components/Motion';

const Cta = () => {
  return (
    <CtaWrapper>
      <CtaPhoto src={boss} />
      <ContentWrapper>
        <TextWrapper>
          <Title color={COLORS.WHITE}>
            Do you need to{' '}
            <span style={{ color: `${COLORS.RED_TITLE}` }}>develop</span> mobile
            app? Do you need to{' '}
            <span style={{ color: `${COLORS.RED_TITLE}` }}>outsource</span>?
          </Title>
          <Text
            text={CTA_DESCRIPTION}
            fontFamily={FONTS.SUBTITLE}
            size={22}
            lineHeight={28}
            color={COLORS.HEADER_TEXT_COLOR}
          />
        </TextWrapper>
        <StyledLink to={ROUTES.CONTACT_US}>{CONTACT_US_TITLE}</StyledLink>
      </ContentWrapper>
    </CtaWrapper>
  );
};
const CtaWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  
  @media screen and (${device.lg}) {
    gap: 40px;
  }
  @media screen and (${device.sm}) {
    gap: 10px;
  }
`;
const ContentWrapper = styled(MotionText)`
  max-width: calc(100% - 720px);
  position: relative;
  z-index: 10;
  
  @media screen and (${device.lg}) {
    max-width: none;
  }
  @media screen and (${device.md}) {
    a {
      margin-top: 15px;
    }
    padding: 10px;
  }
  @media screen and (${device.sm}) {
    a {
      width: 70px;
      padding: 0;
      height: 25px;
      margin-top: 5px;
      font-size: 10px;
      line-height: 14px;
    }
  }
`;
const TextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  position: relative;
  z-index: 10;

  @media screen and (${device.md}){
    > span {
      font-size: 24px;
      line-height: 30px;
    }
    > h4 {
      font-size: 20px;
      line-height: 24px;
    }
    gap: 10px;
  }
  @media screen and (${device.bsm}) {
    > span {
      font-size: 20px;
      line-height: 24px;
    }
    > h4 {
      font-size: 18px;
      line-height: 22px;
    }
  }
  @media screen and (${device.sm}){
    > span {
      font-size: 13px;
      line-height: 18px;
    }
    > h4 {
      font-size: 10px;
      line-height: 14px;
    }
    gap: 0;
  }
`;
const StyledLink = styled(Link)`
  display: flex;
  align-items: center;
  justify-content: center;
  text-decoration: none;
  background-color: ${COLORS.MAIN_RED};
  color: ${COLORS.WHITE};
  cursor: pointer;
  font-size: 16px;
  line-height: 24px;
  font-weight: 400;
  padding: 0;
  width: 130px;
  height: 55px;
  margin-top: 40px;
  font-family: ${FONTS.SUBTITLE};
  &:hover {
    background: ${COLORS.RED_HOVER};
  }
  &:active {
    background: ${COLORS.RED_PRESSED};
  }
  @media screen and (${device.sm}) {
    font-size: 12px;
  }
`;

export default Cta;
